import {
  getCountryList,
  getTranslationList,
  getDictEnumAll,
  getDictMapAll,
  getToken,
  upload
} from '@/api/sys/common'
import {get} from "@/mixin/mixin_request";

const state = {
  countryList: [],
  country: localStorage.getItem('country') ? JSON.parse(localStorage.getItem('country')) : null,
  language: localStorage.getItem('lang') || 'en-US',
  langCode: localStorage.getItem('langCode') || 'en-US',
  dictEnumMapAll: {},
  paramMapAll: {},
  forceLoginOpen: false,
  systemVersion: null,
  siteTitle: null,
  currency: null,
  noticeRead: false,
  accountPanelShow: false,
  itemAddedToCartDialogInfo: { spec: null },
  dictListMapEnum: {},
};
const mutations = {
  put_dictListEnum: (state, { entityName, list }) => {
    Vue.set(state.dictListMapEnum, entityName, list)
  },
  SET_noticeRead: (state, obj) => {
    state.noticeRead = obj;
  },
  SET_dictEnumMap: (state, obj) => {
    state.dictEnumMapAll = obj;
  },
  SET_countryList: (state, list) => {
    state.countryList = list
  },
  SET_lang: (state, lang) => {
    state.language = lang
  },
  SET_country: (state, country) => {
    state.country = country
  },
  SET_dictAllMap: (state, map) => {
    state.paramMapAll = map;
    state.systemVersion = state.paramMapAll["SYSTEM_VERSION"];
    state.siteTitle = state.paramMapAll["SITE_NAME"];
    state.currency = state.paramMapAll["CURRENCY_SYMBOL"] || "$";
    state.forceLoginOpen = map["LOGIN_FORCE_OPEN"] === "1";
    document.title = state.siteTitle;
  },
  SET_accountPanelShow: (state, show) => {
    state.accountPanelShow = show;
  },
  SET_itemAddedToCartDialogInfo: (state, info) => {
    state.itemAddedToCartDialogInfo = info;
  }
};
const actions = {


  getCountryList: async({ commit }) => {
    const list = ( await getCountryList() ).data
    commit('SET_countryList', list)
    return list
  },
  setCountry: async ({commit, dispatch}, country) => {
      localStorage.setItem('country', JSON.stringify(country))
      commit('SET_country', country)
      // country && dispatch('setLang', country.langKey || country.langCode)
  },
  setLang: async ({commit}, lang) => {
      localStorage.setItem('lang', lang)
      commit('SET_lang', lang)
  },
  getTranslationList: async({ commit }) => {
    let data = ( await getTranslationList() ).data;
    return data || []
  },

  getDictEnumAll: async ({ commit }) => {
    commit("SET_dictEnumMap", (await getDictEnumAll()).data);
  },
  getDictMapAll: async ({ commit }) => {
    let map = await getDictMapAll();
    commit("SET_dictAllMap", map);
    return map;
  },
  getToken: async () => {
    return await getToken();
  },
  upload: async (_, data) => {
    return await upload(data);
  },
  dictListComputeIfAbsentEnum: async({ commit, state }, enumClassName) => {
    if (state.dictListMapEnum.hasOwnProperty(enumClassName)) {
      return state.dictListMapEnum[enumClassName]
    } else {
      let list = []
      commit('put_dictListEnum', { entityName: enumClassName, list })
      list = await get(`/common/dictEnumFull/${enumClassName}`)
      commit('put_dictListEnum', { entityName: enumClassName, list })
      return list
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
